// #region imports

// --- Angular
import { Injectable } from "@angular/core";

// --- HS Code
import { CommandResult, RemoteCommand } from "../../../models";

// --- RxJs
import { Observable } from "rxjs";

// #endregion

export interface CommandHandlerResult {
  isSuccess: boolean;
  errorMessage: string;
  results: CommandResult[];
}

// ----------------------------

@Injectable({
  providedIn: 'root'
})
export abstract class CommandHandler {
  protected _commands: RemoteCommand[] = new Array<RemoteCommand>();

  constructor(
  ) {}

  public execute(commands: RemoteCommand[]): Observable<CommandHandlerResult> {
    this._commands = commands;

    return this.executeCommands(commands);
  }

  public undo(): Observable<CommandHandlerResult> {
    const undoCommands = this._commands.slice().reverse().map(c => c.undo());
    this._commands = undoCommands;

    return this.executeCommands(undoCommands);
  }

  public clearCommands(): void {
    this._commands = new Array<RemoteCommand>();
  }

  protected abstract executeCommands(commands: RemoteCommand[]): Observable<CommandHandlerResult>;
}

